import styled from 'styled-components';
import { motion } from 'framer-motion6';
import { th } from 'style/theme';
import { sizes } from 'style';
import { Text } from '../../styled';

export const BenefitIcons = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;

  @media ${sizes.largeDesktop} {
    gap: 20px;
  }

  @media ${sizes.extraLargeDesktop} {
    gap: 24px;
  }
`;

export const BenefitInfo = styled(motion.div)`
  margin-top: 24px;
  border-radius: 8px;
  border: 1px solid ${th('colors.confetti')};
  background-color: ${th('colors.confetti+4')};
  color: ${th('colors.pickledBluewood')};

  @media ${sizes.desktop} {
    border-radius: 16px;
  }
`;

export const BenefitHeading = styled.h4`
  margin: 0;
  margin-bottom: 16px;
  font-size: 20px;
  line-height: 28px;

  @media ${sizes.largeDesktop} {
    margin-bottom: 0;
  }
`;

export const BenefitContent = styled(motion.div)`
  width: 100%;
  padding: 20px;
  overflow: hidden;

  @media ${sizes.largeDesktop} {
    display: grid;
    grid-template-columns: 1fr 250px;
    grid-template-rows: repeat(4, auto);
    grid-column-gap: 24px;
    grid-template-areas:
      'heading heading'
      'description submits'
      'limits submits'
      '. submits';
  }

  > :first-child {
    grid-area: heading;
  }

  > :nth-child(2) {
    grid-area: description;
  }

  > :nth-child(3) {
    grid-area: limits;
  }

  > :nth-child(4) {
    grid-area: submits;
  }
`;

export const InternalLink = styled(Text)`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
  transition: color 200ms;

  :hover {
    color: ${th('colors.primaryLink.hover')};
  }
`;
